import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoaderService } from '@services/loader.service';
import { PlacementService , House} from '@services/placement.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-average-body-weight',
  templateUrl: './average-body-weight.component.html',
  styleUrl: './average-body-weight.component.scss'
})
export class AverageBodyWeightComponent implements OnInit {
  bodyWeightForm: FormGroup;
  @Input() placementId: number | null = null;
  @Input() farmHouseId: number | null = null;
  @Output() closeDialog: EventEmitter<void> = new EventEmitter<void>();
  public isAuthLoading = false;
  public isLoading$: Observable<boolean>;
  @Output() dataSaved: EventEmitter<void> = new EventEmitter<void>();

   public houses: House[] = [];

  constructor(
    private fb: FormBuilder,
    private placementService: PlacementService,
    private toastr: ToastrService,
    private loaderService: LoaderService
  ) { }

  ngOnInit(): void {
    this.bodyWeightForm = this.fb.group({
      placementId: this.placementId,
      farmHouseId: [null, Validators.required],
      date: [this.formatDate(new Date()), Validators.required],
      weights: this.fb.array([this.createWeightField()])
    });
    
    if (this.placementId) {
            this.loadHouses();
        }
  }

  get weights(): FormArray {
    return this.bodyWeightForm.get('weights') as FormArray;
  }
  private loadHouses(): void {
        if (!this.placementId) {
            return;
        }

        this.placementService
            .getHousesByCycleId(this.placementId)
            .subscribe({
                next: (houses: House[]) => {
                    this.houses = houses;
                },
                error: () => {
                    this.toastr.error('Failed to load farm houses');
                }
            });
    }

  formatDate(date: Date): string {
    return date.toISOString().split('T')[0]; // Extracts YYYY-MM-DD
  }

  createWeightField(): FormGroup {
    return this.fb.group({
      weight: ['', [Validators.required, Validators.min(0)]]
    });
  }

  addWeightField(): void {
    this.weights.push(this.createWeightField());
  }

  removeWeightField(index: number): void {
    if (this.weights.length > 1) {
      this.weights.removeAt(index);
    }
  }

  onSubmit(): void {
    this.loaderService.showLoader();
    this.isAuthLoading = true;
    this.markFormGroupTouched(this.bodyWeightForm);
    if (this.bodyWeightForm.valid) {
      const averageBodyWeight = {
        PlacementId: this.bodyWeightForm.value.placementId,
        FarmHouseId: this.bodyWeightForm.value.farmHouseId,
        Date: this.bodyWeightForm.value.date,
        AverageBodyWeight: this.bodyWeightForm.value.weights.map((w: any) => ({ Weight: w.weight.toString() }))
      };
      this.placementService.addActivePlacementWeeklyBodyWeight(averageBodyWeight).subscribe({
        next: (response) => {
          setTimeout(() => {
            this.isAuthLoading = false;
            this.loaderService.hideLoader();
            this.toastr.success("Weekly Average Weight Added Successfully");
            this.dataSaved.emit();
            this.closeDialog.emit(); 
          }, 2000);
        },
        error: (error) => {
          setTimeout(() => {
            this.isAuthLoading = false;
            this.loaderService.hideLoader();
            // Handle login error
            this.toastr.error("Weight Not Added");

          }, 2000);
        }
      });

    }
    else {
      this.bodyWeightForm.markAllAsTouched();
      this.isAuthLoading = false;
      this.loaderService.hideLoader();
    }
    // Perform save operation
  }
  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }
}
